import React from 'react'
import { Button, Form, Input, Select } from 'antd'
import ProjectSelector from '../../ProjectSelector'
import StockroomSelector from '../../StockroomSelector'
import { DEFAULT_INVENTORY_STATUSES, INVENTORY_WORK_FLOW, OPERATIONS } from '../constants'

const STATUS_OPTIONS = Object.entries(INVENTORY_WORK_FLOW).map(([key, { caption }]) => ({ label: caption, value: key }))
const OPERATION_OPTIONS = Object.entries(OPERATIONS).map(([key, { caption }]) => ({ label: caption, value: key }))

const InventoriesFilterPanel = ({ userProjects, onSearch }) => {
  const [form] = Form.useForm()

  const onFormSubmit = ({ project, stockroom, name, current_status, operation_type }) => {
    let filter = Object.assign(
      {},
      buildProjectsFilter(project, stockroom),
      name ? { equipment: { name: { $containsi: name } } } : {},
      current_status ? { current_status: { $in: current_status } } : {},
      operation_type ? { operation_type: { $in: operation_type } } : {}
    )

    onSearch(filter)
  }

  const buildProjectsFilter = (project, stockroom) => {
    if (project && stockroom) {
      return { $or: [{ target_project: project }, { target_stockroom: stockroom }] }
    } else if (!project && !stockroom) {
      return { $or: [{ target_project: { id: { $in: userProjects } } }, { target_project: { id: { $null: true } } }] }
    } else {
      return { target_project: project, target_stockroom: stockroom }
    }
  }

  const onClear = () => {
    form.resetFields()
    onSearch({})
  }

  return (
    <Form
      style={{ display: 'flex' }}
      form={form}
      initialValues={{ current_status: DEFAULT_INVENTORY_STATUSES }}
      layout="vertical"
      onFinish={onFormSubmit}
    >
      <Form.Item style={{ width: 300, maxWidth: 200 }} label="Проект" name="project">
        <ProjectSelector userFilter={true} />
      </Form.Item>
      <Form.Item style={{ marginLeft: 15, width: 200, maxWidth: 200 }} label="Склад" name="stockroom">
        <StockroomSelector />
      </Form.Item>
      <Form.Item style={{ marginLeft: 15, width: 200, maxWidth: 200 }} label="Наименование" name="name">
        <Input allowClear />
      </Form.Item>
      <Form.Item style={{ marginLeft: 15, width: 200, maxWidth: 300 }} label="Операции" name="operation_type">
        <Select mode="multiple" allowClear options={OPERATION_OPTIONS} dropdownMatchSelectWidth={false} />
      </Form.Item>
      <Form.Item style={{ marginLeft: 15 }} label="Статусы заявки" name="current_status">
        <Select mode="multiple" allowClear options={STATUS_OPTIONS} dropdownMatchSelectWidth={false} />
      </Form.Item>
      <Form.Item label="" style={{ marginLeft: 15, marginTop: 30 }}>
        <Button onClick={() => form.submit()}>Применить</Button>
      </Form.Item>
      <Form.Item label="" style={{ marginLeft: 15, marginTop: 30 }}>
        <Button type="dashed" onClick={onClear}>
          Очистить
        </Button>
      </Form.Item>
    </Form>
  )
}

export default InventoriesFilterPanel
